<template>
  <div>
    <div class="accessIndex__general_info">
      <div class="accessIndex__reload">
        <v-hover>
          <div  @click="getSegmentedEmails()" slot-scope="{ hover }" class="accessIndex__reload--container" :class="hover?'accessIndex__interaction--hover':''"  >
            <img src="../../../assets/img/reload_blue.svg">
          </div>
        </v-hover>
        <p class="accessIndex__text--title" >Correos electrónicos</p>
      </div>
      <div  @click="$router.push({name: 'email_new'})"  class="accessIndex__access_items--big_button" >
        <p>CREAR NUEVO</p>
      </div>


    </div>

    <div>
      <v-breadcrumbs>
        <v-icon slot="divider">chevron_right</v-icon>
        <v-breadcrumbs-item>
          <b style="color:#353545">Historial de correos electrónicos</b>
        </v-breadcrumbs-item>
      </v-breadcrumbs>
    </div>
    <v-data-table
      :headers="headers"
      :items="segmentedEmails"
      class="elevation-1">
      <template slot="items" slot-scope="props" >
        <td @click="editItem(props.item)" style="cursor: zoom-in">{{ props.item.attributes.shipment_date | moment("DD/MM/YYYY - hh:mm a") }}</td>
         <td @click="editItem(props.item)" style="cursor: zoom-in">{{ props.item.attributes.affair}}</td>
        <td @click="editItem(props.item)" style="cursor: zoom-in" v-if="props.item.attributes.users && props.item.attributes.users.length >=1">
          {{ props.item.attributes.users.length == 1 ? props.item.attributes.users.length + ' correo' : props.item.attributes.users.length + ' correos'}}
        </td>
        <td @click="editItem(props.item)" style="cursor: zoom-in" v-else>
          -
        </td>
        <td @click="editItem(props.item)" style="cursor: zoom-in" v-if="props.item.attributes.unregistered_users && props.item.attributes.unregistered_users.length >=1">
          {{ props.item.attributes.unregistered_users.length == 1 ? props.item.attributes.unregistered_users.length + ' correo' : props.item.attributes.unregistered_users.length + ' correos'}}
        </td>
        <td @click="editItem(props.item)" style="cursor: zoom-in" v-else>
          -
        </td>
        <!-- <td>{{ props.item.attributes.send_date_time | moment("DD/MM/YYYY")}}</td>
        <td>{{ props.item.attributes.send_date_time | moment("hh:mm a")}}</td> -->
      </template>
    </v-data-table>
    <!-- <p>{{props.item.attributes.users}}</p> -->
    <v-dialog v-model="modal_details" max-width="70%">
      <!-- <v-btn slot="activator" color="primary" dark class="mb-2">New Item</v-btn> -->
      <v-card style="height: fit-content !important;">
        <v-card-title style="border-bottom: 1px solid #E9E9F0">
          <span class="headline">Detalles del correo electrónico</span>
        </v-card-title>
        <v-card-text style="padding: 0">
          <v-container grid-list-md>
            <v-layout wrap>
              <v-flex xs12>
                <span style="font-size: 12px; color: #89899B">Fecha y hora de envío</span>
                <p style="font-size: 14px; margin-bottom: 0">
                  {{editedItem.attributes.shipment_date| moment("DD/MM/YYYY - hh:mm a")}}
                </p>
              </v-flex>
              <v-flex xs12>
                <span style="font-size: 12px; color: #89899B">Asunto</span>
                <p style="font-size: 14px; margin-bottom: 0">
                  {{editedItem.attributes.affair}}
                </p>
              </v-flex>
              <v-flex xs12>
                <span style="font-size: 12px; color: #89899B">Título</span>
                <p style="font-size: 14px; margin-bottom: 0">
                  {{editedItem.attributes.title}}
                </p>
              </v-flex>
              <v-flex xs12>
                <span style="font-size: 12px; color: #89899B">Cuerpo</span>
                <p style="font-size: 14px; margin-bottom: 0; max-height: 170px;overflow-y: scroll;padding: 25px 36px;border: 1px dotted #89899B;"
                  v-html="editedItem.attributes.message">
                </p>
              </v-flex>
              <v-flex xs5 v-if="editedItem.attributes.users.length > 0">
              <span style="font-size: 12px; color: #89899B">Correos registrados ({{editedItem.attributes.users.length}})</span>
              <div
                style="max-height: 125px; overflow-x: hidden; overflow-y: auto"
                >
                <p
                  v-for="(user,index) in editedItem.attributes.users"
                  :key="index"
                  style="font-size: 14px; margin-bottom: 0">
                  {{user}}
                </p>
              </div>
              </v-flex>
              <v-flex xs2 v-if="editedItem.attributes.users.length > 0">
              </v-flex>
              <v-flex xs5 v-if="editedItem.attributes.unregistered_users.length > 0">
                <span style="font-size: 12px; color: #89899B">Correos sin registro ({{editedItem.attributes.unregistered_users.length}})</span>
                <div
                style="max-height: 125px; overflow-x: hidden; overflow-y: auto"
                >
                <p
                  v-for="(unregistered_user,index) in editedItem.attributes.unregistered_users"
                  :key= index
                  style="font-size: 14px; margin-bottom: 0">
                  {{unregistered_user}}
                </p>
                </div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="#353545" flat @click.native="close()">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>


</template>

<script>
export default {
  data () {
    return {
      modal_details: false,
      segmentedEmails: [],
      headers: [
          { text: 'Fecha de envío', value: 'date', sortable: false },
          { text: 'Asunto', sortable: false, value: 'affair' },
          { text: '# Usuarios registrados', value: 'users', sortable: false },
          { text: '# Usuarios sin registrar', value: 'unregistered_users', sortable: false}
         
      ],
      editedItem: {
        attributes:{
          title:'',
          message: '',
          users: [],
          unregistered_users: [],
          send_date_time: null
        }
      },
      defaultItem: {
        attributes:{
          title:'',
          message: '',
          users: [],
          unregistered_users: [],
          send_date_time: null
        }
      },
      editedIndex: -1
    }
  },
  mounted(){
    this.getSegmentedEmails();
  },
  methods: {
    getSegmentedEmails(){
      try {
        this.$http.get('campaign/get_emails',{
          headers:{
            "X-Device-ID": this.getDeviceId(),
            "Authorization": 'Bearer ' + this.getUserToken()
          }
        })
        .then(function(response){
          console.log("ANSWER")
          // console.log(response)
          this.segmentedEmails = response.body.data
          console.log(this.segmentedEmails);
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
          // console.log(response);
          // if(typeof response.body.errors[0].details != "object"){
          //   alert(response.body.errors[0].details);
          // }else{
          //   let message = []
          //   for(var key in response.body.errors[0].details){
          //     message.push(response.body.errors[0].details[key])
          //   }
          //   alert(message);
          // }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    editItem (item) {
      this.editedIndex = this.segmentedEmails.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.modal_details = true
    },
    close () {
      this.modal_details = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
      }, 300)
    }
  },
 
}
</script>



// WEBPACK FOOTER //
// src/components/views/emails/Index.vue